/* Amavil — Gomitas Ardientes landing — interactions (robust, event-delegated) */
(function () {
  'use strict';
  function ready(fn){ if(document.readyState!=='loading'){fn();} else {document.addEventListener('DOMContentLoaded',fn);} }

  /* ---- Horizontal carousels (stories / quotes) via arrow buttons ---- */
  function scrollByCard(track, dir){
    if(!track) return;
    var first = track.querySelector(':scope > *');
    var step = first ? first.getBoundingClientRect().width + 16 : track.clientWidth * 0.85;
    track.scrollBy({ left: dir * step, behavior: 'smooth' });
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest('[data-gma-carr]');
    if(!btn) return;
    var wrap = btn.closest('[data-gma-carrwrap]') || document;
    var track = wrap.querySelector('[data-gma-track]');
    scrollByCard(track, btn.getAttribute('data-gma-carr') === 'next' ? 1 : -1);
  });

  /* ---- Product gallery: arrows + thumbnails + swipe (native scroll-snap) ---- */
  function initGallery(section){
    var track = section.querySelector('[data-gma-gtrack]');
    if(!track) return;
    var slides = track.querySelectorAll('.gma-gslide');
    var thumbs = section.querySelectorAll('.gma-thumb');
    if(!slides.length) return;
    function go(i){
      i = Math.max(0, Math.min(slides.length-1, i));
      var s = slides[i];
      track.scrollTo({ left: s.offsetLeft - track.offsetLeft, behavior:'smooth' });
    }
    function current(){
      var sc = track.scrollLeft, best=0, bd=Infinity;
      slides.forEach(function(s,i){ var d=Math.abs(s.offsetLeft-track.offsetLeft-sc); if(d<bd){bd=d;best=i;} });
      return best;
    }
    section.querySelectorAll('.gma-garrow').forEach(function(a){
      a.addEventListener('click', function(){ go(current() + (a.classList.contains('next')?1:-1)); });
    });
    thumbs.forEach(function(t,i){ t.addEventListener('click', function(){ go(i); }); });
    track.addEventListener('scroll', function(){
      var c = current();
      thumbs.forEach(function(t,i){ t.classList.toggle('is-active', i===c); });
    }, { passive:true });
  }

  /* ---- Sticky bar: hidden on load, show past hero, hide at footer ---- */
  function initSticky(){
    var bar = document.querySelector('[data-gma-sticky]');
    if(!bar) return;
    var buy = document.querySelector('[data-gma-buy]') || document.getElementById('gma-buy');
    var footer = document.querySelector('.footer, footer, [data-gma-footer]');
    var target = bar.getAttribute('data-gma-scrollto') || '#gma-buy';
    var btn = bar.querySelector('.gma-sticky-btn');
    if(btn){ btn.addEventListener('click', function(){
      var el = document.querySelector(target) || buy;
      if(el){ el.scrollIntoView({ behavior:'smooth', block:'start' }); }
    }); }
    function onScroll(){
      var show = false;
      if(buy){
        var r = buy.getBoundingClientRect();
        show = r.bottom < 0;
      } else {
        show = window.scrollY > window.innerHeight * 0.5;
      }
      if(footer){
        var fr = footer.getBoundingClientRect();
        if(fr.top < window.innerHeight - 20) show = false;
      }
      bar.classList.toggle('is-visible', show);
    }
    window.addEventListener('scroll', onScroll, { passive:true });
    window.addEventListener('resize', onScroll, { passive:true });
    onScroll();
  }

  ready(function(){
    document.querySelectorAll('[data-gma-gallery]').forEach(initGallery);
    initSticky();
    /* ensure landing videos buffer + play (autoplay muted loop) */
    document.querySelectorAll('.gma-sec video').forEach(function(v){
      try{ v.muted=true; v.setAttribute('preload','auto'); v.load&&v.load(); v.play&&v.play().catch(function(){}); }catch(e){}
    });
  });
})();
